/**
 * Created by Pankaj on 23-Sep-2019
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {RomanEmpireServerDataParser} from "../RomanEmpireServerDataParser";
import {IRomanEmpireInitData} from "./IRomanEmpireServerData";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class RomanEmpireParsedInitData extends ParsedInitData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    private readonly _isNextGenieReSpin: boolean;
    private readonly _walkingWildsScatterPositions: boolean[][] = [];
    private readonly _wildMultipliers: number[][];
    private readonly _numberOfRespinPlayed: number;

    private readonly _wildMultipliersNextSpin: number[][];

    private readonly _goldenGeniePositionCurrent:number[];
    private readonly _goldenGeniePositionNextSpin:number[];
    private readonly _goldenGenieMultiplierNextSpin:number;
    private readonly _getGoldenGeniePositionPreviousSpin:number[];
    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    private readonly _accumulatedRoundWin:string;

    constructor(rawData: IRomanEmpireInitData, dataParser: RomanEmpireServerDataParser) {
        super(rawData, dataParser);
        this._isNextGenieReSpin = dataParser.getIsNextGenieFreeSpin(rawData);
        this._walkingWildsScatterPositions = dataParser.getOverlayWildsScatter(rawData);
        this._wildMultipliers = dataParser.getWildMultipliers(rawData);

        this._numberOfRespinPlayed = dataParser.getNumberOfRespinPlayed(rawData);
        this._wildMultipliersNextSpin = dataParser.getWildMultipliersNextSpin(rawData);

        this._goldenGeniePositionCurrent = dataParser.getGoldenGeniePositionCurrent(rawData);
        this._goldenGeniePositionNextSpin = dataParser.getGoldenGeniePositionNextSpin(rawData);
        this._goldenGenieMultiplierNextSpin = dataParser.getGoldenGenieMultiplierNextSpin(rawData);
        this._getGoldenGeniePositionPreviousSpin = dataParser.getGoldenGeniePositionPreviousSpin(rawData);
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get isNextGenieReSpin(): boolean {
        return this._isNextGenieReSpin;
    }

    get walkingWildsScatterPositions(): boolean [][] {
        return this._walkingWildsScatterPositions;
    }

    get wildMultipliers(): number[][] {
        return this._wildMultipliers;
    }

    get wildMultipliersNextSpin(): number[][] {
        return this._wildMultipliersNextSpin;
    }

    get numberOfRespinPlayed(): number {
        return this._numberOfRespinPlayed;
    }

    // to fix #49
    protected isFeatureTotalWin(): boolean {
        return (this.mode === RomanEmpireGameMode.GENIE_RESPIN);
    }

    // to fix #49
    protected isNextFeatureTotalWin(): boolean {
        return (this.nextMode === RomanEmpireGameMode.GENIE_RESPIN);
    }


    get goldenGeniePositionCurrent(): number[] {
        //return this._goldenGeniePositionCurrent;

        return this._getGoldenGeniePositionPreviousSpin;
    }

    get goldenGeniePositionNextSpin(): number[] {
        return this._goldenGeniePositionNextSpin;
    }

    get goldenGenieMultiplierNextSpin(): number {
        return this._goldenGenieMultiplierNextSpin;
    }
    get getGoldenGeniePositionPreviousSpin(): number[] {
        return this._getGoldenGeniePositionPreviousSpin;
    }
}